// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-container {
  width: 100%;
  margin-bottom: 20px;
}

.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f9f9f9;
  position: relative;
}

.drop-zone.hovering {
  border-color: #007bff;
  background-color: rgba(0, 123, 255, 0.05);
}

.file-input {
  display: none;
}

.upload-icon {
  font-size: 48px;
  color: #ccc;
  margin-bottom: 10px;
}

.drop-text {
  margin: 10px 0;
  color: #666;
}

.file-info {
  margin-top: 15px;
  padding: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80%;
}

.clear-button {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
}

.error-message {
  color: #dc3545;
  margin-top: 10px;
  font-size: 0.875rem;
}

button.browse-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

button.browse-button:hover {
  background-color: #0069d9;
}

.upload-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  margin-left: 10px;
  cursor: pointer;
}

.upload-button:hover {
  background-color: #45a049;
}

.uploading-message {
  margin-top: 10px;
  color: #0066cc;
}

.success-message {
  margin-top: 10px;
  color: #4CAF50;
}

.card-max-width {
  max-width: 400px;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/shared/file-upload/file-upload.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".file-upload-container {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.drop-zone {\n  border: 2px dashed #ccc;\n  border-radius: 5px;\n  padding: 25px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #f9f9f9;\n  position: relative;\n}\n\n.drop-zone.hovering {\n  border-color: #007bff;\n  background-color: rgba(0, 123, 255, 0.05);\n}\n\n.file-input {\n  display: none;\n}\n\n.upload-icon {\n  font-size: 48px;\n  color: #ccc;\n  margin-bottom: 10px;\n}\n\n.drop-text {\n  margin: 10px 0;\n  color: #666;\n}\n\n.file-info {\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.file-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 80%;\n}\n\n.clear-button {\n  background: none;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n}\n\n.error-message {\n  color: #dc3545;\n  margin-top: 10px;\n  font-size: 0.875rem;\n}\n\nbutton.browse-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\nbutton.browse-button:hover {\n  background-color: #0069d9;\n}\n\n.upload-button {\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 5px 10px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.upload-button:hover {\n  background-color: #45a049;\n}\n\n.uploading-message {\n  margin-top: 10px;\n  color: #0066cc;\n}\n\n.success-message {\n  margin-top: 10px;\n  color: #4CAF50;\n}\n\n.card-max-width {\n  max-width: 400px;\n  margin: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
